import React from 'react'
import { Box, Button, TextField, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { Grid } from '@mui/material'
import { router, usePage, useForm } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

export default function Form({ property, settlement, fiscal_years = [], action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const isEdit = action === 'edit'
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const { data, setData, post, put, processing, errors } = useForm({
    name: settlement.name || '',
    fiscal_year_id: settlement.fiscal_year_id || '',
    settlement_type: settlement.settlement_type || 'hausgeld_settlement',
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`${basePath}/settlements/${settlement.id}`)
    } else {
      post(`${basePath}/settlements`)
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Abrechnung bearbeiten' : 'Neue Abrechnung'}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Hausgeldabrechnungen', href: `${basePath}/settlements` },
          { label: isEdit ? 'Bearbeiten' : 'Neu' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider', maxWidth: 600 }}>
        <Box component="form" onSubmit={handleSubmit} data-testid="settlement-form">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField label="Name" required fullWidth size="small"
                value={data.name} onChange={(e) => setData('name', e.target.value)}
                error={!!allErrors.name} helperText={allErrors.name?.[0]}
                data-testid="name-input" />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small" required error={!!allErrors.fiscal_year_id}>
                <InputLabel>Geschäftsjahr</InputLabel>
                <Select value={data.fiscal_year_id} label="Geschäftsjahr"
                  onChange={(e) => setData('fiscal_year_id', e.target.value)}
                  data-testid="fiscal-year-select"
                >
                  {fiscal_years.map((fy) => (
                    <MenuItem key={fy.id} value={fy.id}>{fy.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Abrechnungsart</InputLabel>
                <Select value={data.settlement_type} label="Abrechnungsart"
                  onChange={(e) => setData('settlement_type', e.target.value)}
                  data-testid="settlement-type-select"
                >
                  <MenuItem value="hausgeld_settlement">Hausgeldabrechnung</MenuItem>
                  <MenuItem value="special_levy_settlement">Sonderumlagenabrechnung</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button type="submit" variant="contained" disabled={processing} data-testid="submit-btn">
              {processing ? 'Wird gespeichert...' : 'Speichern'}
            </Button>
            <Button variant="outlined" onClick={() => router.visit(`${basePath}/settlements`)}>Abbrechen</Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
